import { render } from "./IpromiseLeaguePage.vue?vue&type=template&id=fb3871e6&scoped=true"
import script from "./IpromiseLeaguePage.vue?vue&type=script&lang=js"
export * from "./IpromiseLeaguePage.vue?vue&type=script&lang=js"

import "./IpromiseLeaguePage.vue?vue&type=style&index=0&id=fb3871e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3871e6"]])

export default __exports__